import { supabase } from "@/integrations/supabase/client";
import { type Material } from "@/types";

// Materials API
export const materialsAPI = {
  // Get all materials
  async getMaterials() {
    const { data, error } = await supabase
      .from('materials')
      .select('*')
      .order('name');
    
    if (error) {
      
      throw error;
    }
    
    return data || [];
  },

  // Get materials for a specific project
  async getMaterialsByProject(projectId: string) {
    const { data, error } = await supabase
      .from('materials')
      .select('*')
      .eq('project_id', projectId)
      .order('name');
    
    if (error) {
      
      throw error;
    }
    
    return data || [];
  },

  // Get a specific material by ID
  async getMaterial(materialId: string) {
    const { data, error } = await supabase
      .from('materials')
      .select('*')
      .eq('id', materialId)
      .single();
    
    if (error) {
      
      throw error;
    }
    
    return data;
  },

  // Create a new material
  async createMaterial(materialData: {
    name: string;
    brand?: string;
    model?: string;
    quantity?: string;
    unit?: string;
    area?: string;
    details?: string;
    project_id: string;
    created_by: string;
  }) {
    // Format data for the database
    const formattedData = {
      name: materialData.name,
      brand: materialData.brand,
      quantity: materialData.quantity,
      unit: materialData.unit,
      area: materialData.area,
      details: materialData.details,
      project_id: materialData.project_id,
      user_id: materialData.created_by
    };

    
    
    try {
      const { data, error } = await supabase
        .from('materials')
        .insert(formattedData)
        .select();  // Remove .single() to handle multiple rows if needed
      
      if (error) {
        
        
        throw error;
      }
      
      if (!data || data.length === 0) {
        throw new Error('No data returned after material creation');
      }
      
      return data[0]; // Return the first item since we expect only one
    } catch (error) {
      
      throw error;
    }
  },

  // Update a material
  async updateMaterial(
    materialId: string,
    materialData: {
      name?: string;
      brand?: string;
      model?: string;
      quantity?: string;
      unit?: string;
      area?: string;
      details?: string;
    }
  ) {
    // Remove undefined values to avoid overwriting with null
    const cleanData = { ...materialData };
    Object.keys(cleanData).forEach(key => {
      if (cleanData[key] === undefined) {
        delete cleanData[key];
      }
    });

    
    
    
    try {
      const { data, error } = await supabase
        .from('materials')
        .update(cleanData)
        .eq('id', materialId)
        .select();
      
      if (error) {
        
        
        throw error;
      }
      
      if (!data || data.length === 0) {
        throw new Error('No data returned after material update');
      }
      
      return data[0]; // Return the first item since we expect only one
    } catch (error) {
      
      throw error;
    }
  },

  // Delete a material
  async deleteMaterial(materialId: string) {
    const { error } = await supabase
      .from('materials')
      .delete()
      .eq('id', materialId);
    
    if (error) {
      
      throw error;
    }
    
    return true;
  }
}; 